<template>
  <div class="deposit-form">
    <div v-if="remitList.length > 0">
      <div class="remit-tabs">
        <button v-for="(remit, index) in remitList" :key="index" class="tab-btn"
          :class="{ active: activeTab === index }" @click="activeTab = index">
          匯款單 #{{ index + 1 }}
        </button>
      </div>
      <div class="progress-container" v-for="(remit, index) in remitList" v-show="activeTab === index">
        <div class="progress-header">
          <h3>匯款處理進度</h3>
        </div>

        <div class="progress-steps">
          <!-- 第一步：提交信息 -->
          <div class="step active">
            <div class="step-icon">1</div>
            <div class="step-content">
              <h4>匯款信息已提交</h4>
              <p>匯款金額：{{ remit.currency }} {{ remit.amount }}</p>
              <p>提交時間：{{ remit.time }}</p>
            </div>
          </div>

          <!-- 第二步：客服审核 -->
          <div v-if="remit.status == 0" class="step">
            <div class="step-icon">2</div>
            <div class="step-content">
              <h4>客服審核中</h4>
              <p>預計審核時間：2小時内</p>
            </div>
          </div>
          <div v-if="remit.status == 1" class="step active">
            <div class="step-icon">2</div>
            <div class="step-content">
              <h4 style="color: red;">客服審核未通過</h4>
              <p>審核時間：{{ remit.auditTime }}</p>
            </div>
          </div>
          <div v-if="remit.status == 3" class="step active">
            <div class="step-icon">2</div>
            <div class="step-content">
              <h4 style="color: green;">客服審核通過</h4>
              <p>審核時間：{{ remit.auditTime }}</p>
            </div>
          </div>

          <!-- 第三步：发货状态 -->
          <div v-if="remit.status != 3" class="step">
            <div class="step-icon">3</div>
            <div class="step-content">
              <h4>待發貨</h4>
              <p>審核通過后將立即發貨</p>
            </div>
          </div>
          <div v-if="remit.status == 3" class="step active">
            <div class="step-icon">3</div>
            <div class="step-content">
              <h4 style="color: green;">已完成</h4>
              <p>完成時間：{{ remit.auditTime }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  isEmpty,
  isNotEmpty
} from '../utils/index.js'
export default {
  name: 'BankRemitData',
  data() {
    return {
      activeTab: 0,
      remitList: []
    }
  },
  mounted() {
    this.loadBankRemitInfo();
  },
  methods: {
    loadBankRemitInfo: function () {
      let _role = this.$cache.getRoleInfo();
      if (this.$session.hasLogin() && isNotEmpty(_role)) {
        const _param = {
          userId: this.$session.getUserId(),
          gameCode: this.$cache.getGameCode(),
          serverCode: _role.serverCode,
          roleId: _role.roleId
        };

        this.$axios({
          method: 'get',
          url: '/web/api/remit/loadBankRemitInfo',
          params: _param
        })
          .then(response => {
            if (response.code === 1000) {
              this.remitList = response.data;
            }
          })
      }
    },
  }
}
</script>

<style scoped>
.remit-tabs {
  display: flex;
  margin-bottom: 20px;
  border-bottom: 1px solid #e0e0e0;
}

.tab-btn {
  padding: 10px 20px;
  background: none;
  border: none;
  border-bottom: 2px solid transparent;
  cursor: pointer;
  font-size: 14px;
  color: #666;
  transition: all 0.3s;
}

.tab-btn.active {
  color: #03d2ff;
  border-bottom-color: #03d2ff;
  font-weight: bold;
}

.progress-container {
  all: initial;
  /* 重置所有继承样式 */
  display: block;
  background: white;
  border-radius: 8px;
  padding: 20px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif;
}

.progress-header h3 {
  all: initial;
  /* 重置标题样式 */
  display: block;
  margin: 0 0 20px;
  color: #333;
  font-size: 18px;
  font-weight: bold;
  font-family: inherit;
}

.progress-steps {
  position: relative;
  padding-left: 30px;
}

.progress-steps::before {
  content: '';
  position: absolute;
  left: 15px;
  top: 0;
  bottom: 0;
  width: 2px;
  background: #e0e0e0;
}

.step {
  position: relative;
  margin-bottom: 25px;
  display: flex;
}

.step-icon {
  width: 30px;
  height: 30px;
  line-height: 30px;
  border-radius: 50%;
  background: #e0e0e0;
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 15px;
  z-index: 1;
}

.step.active .step-icon {
  background: #03d2ff;
}

.step-content {
  flex: 1;
}

.step-content h4 {
  all: initial;
  /* 重置h4样式 */
  display: block;
  margin: 0 0 5px;
  color: #333;
  font-size: 16px;
  font-weight: bold;
  font-family: inherit;
}

.step-content p {
  all: initial;
  /* 重置p样式 */
  display: block;
  margin: 0;
  color: #666;
  font-size: 14px;
  font-family: inherit;
  line-height: 1.5;
}

@media (max-width: 768px) {
  .progress-container {
    padding: 15px;
  }

  .progress-steps {
    padding-left: 25px;
  }
}
</style>